// extracted by mini-css-extract-plugin
module.exports = {"disabledIcon":"leadsIconTable_disabledIcon__34XRl","icon":"leadsIconTable_icon__3yT-8"};